import ReservedProfileId from '../pages/ReservedProfileId';

const ReservedProfileIdRoutes = [
  {
    breadcrumb: [{ path: '/reserved-profile-id', breadcrumbName: 'Reserved User Name' }],
    Component: ReservedProfileId,
  },
];

export default ReservedProfileIdRoutes;
